var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('loading',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingShow),expression:"loadingShow"}]}),_c('section',[(_vm.routerViewShow)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }